import * as ClientTypes from "../DataTypes/clientTypes";
import * as OrgInfoTypes from "../../Common/organisationInfo";

export function applyDiscount(amount: number, discount: number, discountType: ClientTypes.DiscountType) {
    if (discount > 0) {
        return discountType === ClientTypes.DiscountType.Percentage ? amount * (1 - discount) : amount - discount;
    }

    return amount;
}

export function applyTax(taxUsage: OrgInfoTypes.TaxUsageType, amount: number, taxRate?: number) {
    if (taxUsage !== OrgInfoTypes.TaxUsageType.Excluding || !taxRate) {
        return amount;
    }

    amount = amount * (1 + taxRate);

    return amount;
}
